//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponList from '../index.vue';
export default {
  name: 'CouponFrom',
  components: {
    couponList: couponList
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      handle: '',
      keyNum: 0,
      coupons: [],
      userIds: '',
      userType: ''
    };
  },
  watch: {
    // show() {
    //   this.visible = this.show
    // }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.visible = false;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    getCouponId: function getCouponId(couponObj) {
      this.callback(couponObj);
      this.visible = false;
    }
  }
};